module.exports = __webpack_public_path__ + "static/media/pooltogether-icon.c4fc3b04.png";